export interface VirtualClinicAnalysisOperatingNumberItem {
  type: 'node' | 'leaf';
  label: VirtualClinicAnalysisOperatingNumberItemLabel;
}

export interface VirtualClinicAnalysisOperatingNumberNodeItem
  extends VirtualClinicAnalysisOperatingNumberItem {
  aggregated: number;
  groupedValues: VirtualClinicAnalysisOperatingNumberItem[];
}

export interface VirtualClinicAnalysisOperatingNumberLeafItem
  extends VirtualClinicAnalysisOperatingNumberItem {
  value: number;
}

export interface VirtualClinicAnalysisOperatingNumberItemLabel {
  key: string;
  longDisplayName: string;
  shortDisplayName: string;
}

export class VirtualClinicAnalysisOperatingNumberItemHelper {
  public static isNode(
    item: VirtualClinicAnalysisOperatingNumberItem,
  ): item is VirtualClinicAnalysisOperatingNumberNodeItem {
    return item.type === 'node';
  }

  public static isLeaf(
    item: VirtualClinicAnalysisOperatingNumberItem,
  ): item is VirtualClinicAnalysisOperatingNumberLeafItem {
    return item.type === 'leaf';
  }
}
